var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('v-container',{class:{ 'fill-height': _vm.fillHeight, 'px-0': _vm.$vuetify.breakpoint.mobile },attrs:{"fluid":_vm.fluid}},[_c('alert-unsupported-browser'),_c('transition',{attrs:{"name":"fade-fast","mode":"out-in"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }